module.exports = __webpack_public_path__ + "assets/a484684e9f5218bf52fcfdfcf4862277.png";